function setOGlobal(name, obj) {
    window.o_global =
        window.o_global || {};
    /*🤫*/
    window.o_global[name] =
        window.o_global[name] || obj;
    return window.o_global[name];
}
/*🤫
🤫
🤫*/
const topicValidationPattern = /^[\w-]{2,}\.[\w-]{3,}(\.[\w-]{3,})+$/;
/*🤫
🤫
🤫
🤫*/
function validateTopic(topic) {
    if (!(typeof topic === "string" && topicValidationPattern.test(topic))) {
        throw new Error(`eventQBus: topic name '${topic}' is invalid, please match regex syntax '${topicValidationPattern.toString()}' (e.g. "assets.rum.fired")`);
    }
}
/*🤫
🤫
🤫*/
const moduleValidationPattern = /^@?[\w-]{2,}\.[\w-]{3,}(\.[\w-]{3,})+$/;
function validateModuleId(moduleId) {
    if (!(typeof moduleId === "string" && moduleValidationPattern.test(moduleId))) {
        throw new Error(`eventQBus: module name '${moduleId}' is invalid, please match regex syntax '${moduleValidationPattern.toString()}' (e.g. "assets.global-resources.head")`);
    }
}
/*🤫
🤫
🤫*/
const LOG_COOKIE = "EVENT_Q_BUS_DEBUG";
/*🤫
🤫
🤫*/
const TRACE_COOKIE = "EVENT_Q_BUS_TRACE";
const loggingOptions = {};
function clearOptions() {
    delete loggingOptions.enabled;
    delete loggingOptions.logger;
    delete loggingOptions.pattern;
    delete loggingOptions.tracing;
}
/*🤫
🤫
🤫
🤫
🤫*/
function toPattern(pattern) {
    return typeof pattern === "string" ? new RegExp(pattern) : pattern;
}
/*🤫
🤫
🤫
🤫*/
function initOptions() {
    var _a;
    const logCookie = (_a = window.o_util) === null || _a === void 0 ? void 0 : _a.cookie.get(LOG_COOKIE);
    try {
        if (logCookie) {
            loggingOptions.pattern = toPattern(logCookie);
            loggingOptions.enabled = true;
            const traceCookie = window.o_util.cookie.get(TRACE_COOKIE);
            loggingOptions.tracing = traceCookie === "true";
            /*🤫*/
            loggingOptions.logger = console.log;
        }
        else {
            clearOptions();
        }
        return loggingOptions;
    }
    catch (_b) {
        clearOptions();
        return loggingOptions;
    }
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function setLog(pattern, options) {
    var _a, _b, _c, _d;
    if (!pattern) {
        (_a = window.o_util) === null || _a === void 0 ? void 0 : _a.cookie.remove(LOG_COOKIE);
        (_b = window.o_util) === null || _b === void 0 ? void 0 : _b.cookie.remove(TRACE_COOKIE);
        clearOptions();
    }
    else {
        loggingOptions.enabled = true;
        loggingOptions.pattern = toPattern(pattern);
        (_c = window.o_util) === null || _c === void 0 ? void 0 : _c.cookie.set(LOG_COOKIE, loggingOptions.pattern.source);
        if (options === null || options === void 0 ? void 0 : options.withTrace) {
            (_d = window.o_util) === null || _d === void 0 ? void 0 : _d.cookie.set(TRACE_COOKIE, "true");
            loggingOptions.tracing = true;
        }
        /*🤫*/
        loggingOptions.logger = (options === null || options === void 0 ? void 0 : options.logFunc) || console.log;
    }
    return loggingOptions;
}
function logEnabled(options) {
    return options.enabled === true;
}
/*🤫
🤫
🤫
🤫
🤫*/
function logger(namespace) {
    return (topic, format, ...args) => Promise.resolve()
        .then(() => {
        if (logEnabled(loggingOptions) && loggingOptions.pattern.test(topic)) {
            loggingOptions.logger(`[log] ${namespace} [${topic}] ${format}`, ...args);
        }
    })
        .catch(() => {
        /*🤫*/
    });
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function arrayRemove(array, item) {
    const index = array.indexOf(item);
    if (index > -1) {
        array.splice(index, 1);
        return item;
    }
    return undefined;
}
function arrayContainsAll(toContain, toBeContained) {
    return (toBeContained.filter((tbc) => toContain.some((tc) => tc === tbc)).length ===
        toBeContained.length);
}
function arrayEqualsAll(arr1, arr2) {
    return arr1.length === arr2.length && arrayContainsAll(arr1, arr2);
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function filterByPattern(list, pattern) {
    return pattern ? list.filter((i) => pattern.test(i)) : list.slice();
}

/*🤫*/
const log$1 = logger("event-q-bus:topic");
/*🤫
🤫
🤫
🤫*/
class QBusTopic {
    /*🤫
🤫
🤫
🤫
🤫
🤫*/
    constructor(name) {
        /*🤫
🤫
🤫*/
        this.listeners = [];
        /*🤫
🤫
🤫
🤫*/
        this.dataQueue = [];
        /*🤫
🤫
🤫
🤫*/
        this.retained = false;
        this.topicName = name;
    }
    /*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
    queueData(eventData = []) {
        this.dataQueue.push(eventData);
        return eventData;
    }
    /*🤫
🤫
🤫
🤫*/
    clearQueue() {
        this.dataQueue.splice(0);
    }
    /*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
    addListener(callback, singleRun = false) {
        /*🤫*/
        const listener = { singleRun, callback };
        /*🤫*/
        if (!this.listeners.some((item) => listener.singleRun === item.singleRun && listener.callback === item.callback)) {
            log$1(this.topicName, "add new listener", callback.name);
            this.listeners.push(listener);
        }
        return listener;
    }
    /*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
    removeByCallback(callback) {
        let res = false;
        if (callback) {
            this.listeners
                .filter((l) => l.callback === callback)
                .forEach((listener) => {
                this.removeListener(listener);
                res = true;
            });
        }
        return res;
    }
    /*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
    emitAllListener(eventData = []) {
        return Promise.all([...this.listeners].map((listener) => {
            return this.emitListener(listener, eventData);
        }));
    }
    /*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
    emitListenerWithQueuedData(listener) {
        /*🤫*/
        /*🤫*/
        if (this.dataQueue.length > 0) {
            /*🤫*/
            /*🤫*/
            if (listener.singleRun) {
                return Promise.all([this.emitListener(listener, this.dataQueue[0])]);
            }
            return Promise.all(this.dataQueue.map((eventData) => {
                return this.emitListener(listener, eventData);
            }));
        }
        return Promise.resolve([]);
    }
    /*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
    emitListener(listener, eventData) {
        /*🤫*/
        if (listener.singleRun) {
            this.removeListener(listener);
        }
        /*🤫*/
        log$1(this.topicName, "dispatch %s", listener.callback.name);
        const res = Promise.resolve().then(() => listener.callback.call(this, ...eventData));
        if (loggingOptions.tracing) {
            return res.catch((e) => {
                log$1(this.topicName, "listener errored with:", e.stack || e.message || e);
                throw e;
            });
        }
        return res;
    }
    /*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
    removeListener(listener) {
        const removed = arrayRemove(this.listeners, listener);
        if (removed) {
            log$1(this.topicName, "removed listener", removed.callback.name);
            return true;
        }
        return false;
    }
}

/*🤫*/
const log = logger("event-q-bus:store");
/*🤫
🤫
🤫
🤫
🤫
🤫*/
class QBusStore {
    /*🤫
🤫
🤫
🤫*/
    constructor(options = {}) {
        /*🤫
🤫
🤫*/
        this.map = {};
        this.isBusMode = options.isBusMode || false;
        if (!options.ignoreAllScriptsExecuted) {
            this.initBusSwitchEvent();
        }
    }
    initBusSwitchEvent() {
        var _a, _b;
        /*🤫*/
        /*🤫*/
        if (typeof ((_b = (_a = window.o_global) === null || _a === void 0 ? void 0 : _a.eventLoader) === null || _b === void 0 ? void 0 : _b.onAllScriptsExecuted) === "function") {
            log("store", "Subscribe on onAllScriptsExecuted");
            window.o_global.eventLoader.onAllScriptsExecuted(1000, () => {
                log("store", "All Scripts were Executed, flush all events");
                /*🤫*/
                this.isBusMode = true;
                /*🤫*/
                this.clearQueues();
            });
        }
    }
    /*🤫
🤫
🤫
🤫
🤫
🤫*/
    get(topic) {
        return this.map[topic];
    }
    /*🤫
🤫
🤫
🤫
🤫*/
    /*🤫*/
    /*🤫*/
    clearAll() {
        /*🤫*/
        Object.keys(this.map).forEach((k) => {
            delete this.map[k];
        });
    }
    /*🤫*/
    /*🤫
🤫
🤫
🤫*/
    clearQueues() {
        /*🤫*/
        Object.entries(this.map).forEach(([_, topic]) => {
            topic.clearQueue();
        });
    }
    /*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
    getOrAddTopic(topic) {
        const res = this.get(topic);
        if (!(res instanceof QBusTopic)) {
            this.map[topic] = new QBusTopic(topic);
            return this.map[topic];
        }
        return res;
    }
}

function moduleEventName(event) {
    return `assets.module.${event}`;
}
/*🤫
🤫
🤫
🤫*/
class ModuleEventsManager {
    constructor(options) {
        /*🤫
🤫
🤫*/
        this.loadedModules = [];
        /*🤫
🤫
🤫*/
        this.onModuleLoadedListeners = [];
        /*🤫
🤫
🤫*/
        this.initializedModules = [];
        /*🤫
🤫
🤫*/
        this.onModuleInitializedListeners = [];
        this.store = options.store;
        this.ignoreModuleEvents = options.ignoreModuleEvents;
        this.init();
    }
    /*🤫
🤫
🤫
🤫*/
    init() {
        if (!this.ignoreModuleEvents) {
            this.initModuleLoadEvent();
            this.initModuleInitializedEvent();
        }
    }
    /*🤫
🤫
🤫
🤫
🤫
🤫*/
    initModuleEvent(event, modules, listeneres) {
        const topic = this.store.getOrAddTopic(event);
        topic.addListener((data) => {
            if (!modules.includes(data.moduleId)) {
                /*🤫*/
                modules.push(data.moduleId);
            }
            /*🤫*/
            [...listeneres].forEach((l) => {
                const fullFilled = arrayContainsAll(modules, l.dependencyIds);
                /*🤫*/
                if (fullFilled) {
                    arrayRemove(listeneres, l);
                    l.callbacks.forEach((c) => c({ moduleId: l.moduleId, dependencyIds: l.dependencyIds }));
                }
            });
        });
    }
    /*🤫
🤫
🤫*/
    initModuleLoadEvent() {
        this.initModuleEvent(moduleEventName("loaded"), this.loadedModules, this.onModuleLoadedListeners);
    }
    /*🤫
🤫
🤫*/
    initModuleInitializedEvent() {
        this.initModuleEvent(moduleEventName("initialized"), this.initializedModules, this.onModuleInitializedListeners);
    }
    /*🤫*/
    addModuleListener(params, callback, listeners) {
        validateModuleId(params.moduleId);
        params.dependencyIds.forEach(validateModuleId);
        let listener = listeners.find((l) => params.moduleId === l.moduleId && arrayEqualsAll(params.dependencyIds, l.dependencyIds));
        if (!listener) {
            listener = { moduleId: params.moduleId, dependencyIds: params.dependencyIds, callbacks: [] };
            listeners.push(listener);
        }
        if (!listener.callbacks.includes(callback)) {
            listener.callbacks.push(callback);
        }
        return listener;
    }
    /*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
    addModuleLoadListener(params, callback) {
        return this.addModuleListener(params, callback, this.onModuleLoadedListeners);
    }
    /*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
    addModuleInitializedListener(params, callback) {
        return this.addModuleListener(params, callback, this.onModuleInitializedListeners);
    }
    /*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
    /*🤫*/
    emitModuleListener(modules, listeneres, listener) {
        const registered = listeneres.includes(listener);
        const fullFilled = arrayContainsAll(modules, listener.dependencyIds);
        if (fullFilled && registered) {
            arrayRemove(listeneres, listener);
            return Promise.all(listener.callbacks.map((c) => c({ moduleId: listener.moduleId, dependencyIds: listener.dependencyIds })));
        }
        return undefined;
    }
    /*🤫
🤫
🤫
🤫
🤫
🤫*/
    emitModuleLoadedListener(listener) {
        return this.emitModuleListener(this.loadedModules, this.onModuleLoadedListeners, listener);
    }
    /*🤫
🤫
🤫
🤫
🤫
🤫*/
    emitModuleInitializedListener(listener) {
        return this.emitModuleListener(this.initializedModules, this.onModuleInitializedListeners, listener);
    }
}

export { LOG_COOKIE as L, ModuleEventsManager as M, QBusStore as Q, TRACE_COOKIE as T, validateModuleId as a, setLog as b, clearOptions as c, logEnabled as d, logger as e, arrayRemove as f, arrayContainsAll as g, arrayEqualsAll as h, initOptions as i, filterByPattern as j, QBusTopic as k, loggingOptions as l, moduleEventName as m, setOGlobal as s, toPattern as t, validateTopic as v };
/*🤫*/
